<template>
	<div id="Zmyy" style="margin-top:-20px;">

		<div class="g-right-middle width800">
			<div class="g-ypxx">
				<i>*提示："我的写真"要保证同时上传7张才有效哦！</i>
				<div class="actor-show2">
					<ul>
						<li>
							<div class="imgxz1">
								<img :src="this.pic1" width="185" height="134" @click="centerDialogVisible1=true">
								<!-- <input type="file" class="imgup1" @change="addpic1($event)"> -->
								<el-dialog title="我的写真"  :close-on-click-modal='false' :visible.sync="centerDialogVisible1" width="33.5%">
									<M_Pic1></M_Pic1>
								</el-dialog>
							</div>
							<div class="p-show imgxz2">
								<img :src="this.pic2" width="185" height="264" @click="centerDialogVisible2=true">
								<!-- <input type="file" class="imgup2" @change="addpic2($event)"> -->
								<el-dialog title="我的写真"  :close-on-click-modal='false' :visible.sync="centerDialogVisible2" width="33.5%">
									<M_Pic2></M_Pic2>
								</el-dialog>
							</div>
						</li>
						<li class="p-show2">
							<div class="imgxz2">
								<img :src="this.pic3" width="185" height="264" @click="centerDialogVisible3=true">
								<el-dialog title="我的写真"  :close-on-click-modal='false' :visible.sync="centerDialogVisible3" width="33.5%">
									<M_Pic3></M_Pic3>
								</el-dialog>
							</div>
							<div class="p-show">
								<img src="http://yopoo.oss-cn-beijing.aliyuncs.com/casting.jpg" style="background: #999;" width="100%" height="auto">
							</div>
						</li>
						<li class="p-show2">
							<div class="imgxz1">
								<img :src="this.pic4" width="185" height="134" @click="centerDialogVisible4=true">
								<el-dialog title="我的写真"  :close-on-click-modal='false' :visible.sync="centerDialogVisible4" width="33.5%">
									<M_Pic4></M_Pic4>
								</el-dialog>
							</div>
							<div class="p-show imgxz2">
								<img :src="this.pic5" width="185" height="264" @click="centerDialogVisible5=true">
								<el-dialog title="我的写真"  :close-on-click-modal='false' :visible.sync="centerDialogVisible5" width="33.5%">
									<M_Pic5></M_Pic5>
								</el-dialog>
							</div>
						</li>
						<li class="p-show2">
							<div class="imgxz2">
								<img :src="this.pic6" width="185" height="264" @click="centerDialogVisible6=true">
								<el-dialog title="我的写真" :close-on-click-modal='false' :visible.sync="centerDialogVisible6" width="33.5%">
									<M_Pic6></M_Pic6>
								</el-dialog>

							</div>
							<div class="p-show imgxz1">
								<img :src="this.pic7" width="185" height="134" @click="centerDialogVisible7=true">
								<el-dialog title="我的写真" :close-on-click-modal='false' :visible.sync="centerDialogVisible7" width="33.5%">
									<M_Pic7></M_Pic7>
								</el-dialog>

							</div>
						</li>
					</ul>
					<div class="clearfix"></div>

				</div>

				<center><input @click="uploadinfor" type="button" class="g-btn" value="下一步"></center>

			</div>


		</div>
	</div>
</template>
<script>
	import Axios from 'axios'
	import storage from '../../../storage/storage.js'
	import M_Pic1 from '@/components/per_admin/edit/M_Pic1.vue'
	import M_Pic2 from '@/components/per_admin/edit/M_Pic2.vue'
	import M_Pic3 from '@/components/per_admin/edit/M_Pic3.vue'
	import M_Pic4 from '@/components/per_admin/edit/M_Pic4.vue'
	import M_Pic5 from '@/components/per_admin/edit/M_Pic5.vue'
	import M_Pic6 from '@/components/per_admin/edit/M_Pic6.vue'
	import M_Pic7 from '@/components/per_admin/edit/M_Pic7.vue'

	export default {
		data() {
			return {
				pic1: storage.get('imgsrc1'),
				pic2: storage.get('imgsrc2'),
				pic3: storage.get('imgsrc3'),
				pic4: storage.get('imgsrc4'),
				pic5: storage.get('imgsrc5'),
				pic6: storage.get('imgsrc6'),
				pic7: storage.get('imgsrc7'),
				uid: '',
				centerDialogVisible1: false,  //基本信息修改的状态属性
				centerDialogVisible2: false,  //基本信息修改的状态属性
				centerDialogVisible3: false,  //基本信息修改的状态属性
				centerDialogVisible4: false,  //基本信息修改的状态属性
				centerDialogVisible5: false,  //基本信息修改的状态属性
				centerDialogVisible6: false,  //基本信息修改的状态属性
				centerDialogVisible7: false,  //基本信息修改的状态属性
			}
		},
		components:{
			M_Pic1,
			M_Pic2,
			M_Pic3,
			M_Pic4,
			M_Pic5,
			M_Pic6,
			M_Pic7,
		},
		methods: {
			uploadinfor(event) {
				var api = 'https://api.yopoo.cn/api/centre/createcast'

				//定义form表单的格式并实例化
				
				let config = {
					pic1:this.pic1,
					pic2:this.pic2,
					pic3:this.pic3,
					pic4:this.pic4,
					pic5:this.pic5,
					pic6:this.pic6,
					pic7:this.pic7,
					uid:storage.get('userdata')
				}

				if (this.pic1 == '' || this.pic2 == '' || this.pic3 == '' || this.pic4 == '' || this.pic5 == '' || this.pic6 == '' ||
					this.pic7 == '') {
					this.$message({
						message: '请上传相关图片！',
						type: 'warning',
						center: true

					});
				}
				Axios.post(api, config).then((res) => {
					// console.log(res.data)
					if (res.data.code == '200') {
						setTimeout(() => { //测试uid暂时取消跳转
							this.$message({
								message: res.data.msg,
								type: 'success',
								center: true

							});
							this.$router.push({
									path: '/per_admin/edit/wdsp',
								}

							) //登录后跳转页面


						}, 200);
						storage.set('wdxz', 'wdxz') //保存填写状态，代表已经填写完，用以判断导航禁用
					}
					if (res.data.code == '202') {
						this.$message({
							message: res.data.msg,
							type: 'error',
							center: true

						});
					}

				}).catch((res) => {

				})

			}
		},
		


	}
</script>

<style>
.actor-show2 img{
	display: block;
}
.m_kind img{
	display: block;border: 1px dashed #999;
}
</style>



// WEBPACK FOOTER //
// src/components/per_admin/edit/P_Wdxz.vue